/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFolderCode = createReactComponent("folder-code", "IconFolderCode", [
  [
    "path",
    {
      d: "M11 19h-6a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M20 21l2 -2l-2 -2", key: "svg-1" }],
  ["path", { d: "M17 17l-2 2l2 2", key: "svg-2" }]
]);

export { IconFolderCode as default };
//# sourceMappingURL=IconFolderCode.js.map
